import { render, staticRenderFns } from "./viewCollectSku.vue?vue&type=template&id=c9c0bdfa&scoped=true"
import script from "./viewCollectSku.vue?vue&type=script&lang=js"
export * from "./viewCollectSku.vue?vue&type=script&lang=js"
import style0 from "./viewCollectSku.vue?vue&type=style&index=0&id=c9c0bdfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c0bdfa",
  null
  
)

export default component.exports